import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4d52f168"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "h-100 f-row f-center-start" }
const _hoisted_2 = { class: "game__rules f f-center-center" }
const _hoisted_3 = { class: "game__leaderboard h-100 f f-center-center" }
const _hoisted_4 = { class: "f-1 f-start-start" }
const _hoisted_5 = {
  class: /*#__PURE__*/_normalizeClass(`mr-2 game__leaderboard__player f-row f-start-center`),
  style: `--nth: 0s`
}
const _hoisted_6 = { class: "f-row f-center-center" }
const _hoisted_7 = { class: "t-left" }
const _hoisted_8 = { class: "t-small mb-0" }
const _hoisted_9 = { class: "t-normal" }
const _hoisted_10 = {
  key: 0,
  class: "a-appear-bounce-up fa-solid fa-caret-left"
}
const _hoisted_11 = { class: "game__canvas" }
const _hoisted_12 = { class: "game__content" }




export default /*#__PURE__*/_defineComponent({
  __name: 'GameOverlayDefault',
  props: {
    players: Object,
    leaderBoard: [Object],
    currentPlayer: Number,
    isFinished: Boolean,
    rules: String,
},
  setup(__props) {

const props = __props;



const colors: { [key: string]: string } = {
    white: "#ffffff",
    red: "#fad1e2",
    orange: "#fae0d1",
    yellow: "#faf8d1",
    green: "#d2fad1",
    sky: "#d1f2fa",
    blue: "#d1d6fa",
    purple: "#e3d1fa",
    pink: "#fad1f3",
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.rules, (rule, index) => {
        return (_openBlock(), _createElementBlock("div", {
          style: _normalizeStyle(`--nth: 0.${5 + index}s`),
          class: "game__rule",
          key: index
        }, _toDisplayString(rule), 5))
      }), 128))
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.leaderBoard, (player, index) => {
          return (_openBlock(), _createElementBlock("div", {
            key: `${index}${player}`,
            class: "f-row f-start-center"
          }, [
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("div", {
                style: _normalizeStyle(`background: ${
                                colors[__props.leaderBoard?.[2] || 'white']
                            }`),
                class: "game__leaderboard__player__content"
              }, [
                _createElementVNode("div", _hoisted_6, [
                  _createElementVNode("div", _hoisted_7, [
                    _createElementVNode("div", _hoisted_8, " #" + _toDisplayString(index + 1) + " - " + _toDisplayString(player[0]), 1),
                    _createElementVNode("div", _hoisted_9, _toDisplayString(player[1]), 1)
                  ])
                ])
              ], 4)
            ]),
            (Number(index) === __props.currentPlayer)
              ? (_openBlock(), _createElementBlock("i", _hoisted_10))
              : _createCommentVNode("", true)
          ]))
        }), 128))
      ])
    ]),
    _createElementVNode("div", _hoisted_11, [
      _createElementVNode("div", _hoisted_12, [
        _renderSlot(_ctx.$slots, "default")
      ])
    ])
  ]))
}
}

})